export default __webpack_public_path__ + "static/media/Poppins-Medium.563f976d.woff2";